import { createColumnHelper } from "@tanstack/react-table";
import { IPartsDescription } from "./utils/PartsDescription-utils";
import PartsDescriptionActionButton from "./utils/ParstDescriptionActionsButtons";
import Chip from "@mui/material/Chip";
import { usePermission } from "../../../../hooks/usePermissions";
import { Modules, Permissions } from "../../../Users/Roles/roles-utils";

const columnHelper = createColumnHelper<IPartsDescription>();

const PartsDescriptionColumns = () => {
  const hasEditPermission = usePermission(
    Modules.mmdPd.accessKey,
    Permissions.edit
  );
  const hasDeletePermission = usePermission(
    Modules.mmdPd.accessKey,
    Permissions.delete
  );

  return [
    columnHelper.accessor("id", {
      id: "id",
      header: "Item No",
      cell: ({ row }) => row.index + 1,
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("description", {
      id: "description",
      header: "description",
      cell: (row) => row.renderValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("isActive", {
      id: "isActive",
      header: "Status",
      cell: (row) => (
        <Chip
          label={row.getValue() ? "Active" : "Inactive"}
          color={row.getValue() ? "primary" : "warning"}
          style={{ color: row.getValue() ? "white" : "white", height: "25px" }}
        />
      ),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    ...(hasEditPermission || hasDeletePermission
      ? [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => (
              <PartsDescriptionActionButton PartsDescription={row.original}  hasEditPermission={hasEditPermission} hasDeletePermission={hasDeletePermission} />
            ),
            enableHiding: false,
          }),
        ]
      : []),
  ];
};

export default PartsDescriptionColumns;
